
const defaultExport = {
  methods: {
    toHome() {
      this.$router.push({ name: 'Home' });
    }
  }
};

import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "../../_snowpack/pkg/vue.js"

const _hoisted_1 = { class: "container mt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "fw-bolder text-center p-5 m-3" }, "SpaceX 🤝 GraphQL", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-center display-1" }, "404", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h5", { class: "text-center display-6 text-muted mt-3" }, " Mission control, this is not the page you are looking for. ", -1)
const _hoisted_5 = { class: "d-flex justify-content-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-reply-fill me-2",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M5.921 11.9 1.353 8.62a.719.719 0 0 1 0-1.238L5.921 4.1A.716.716 0 0 1 7 4.719V6c1.5 0 6 0 7 8-2.5-4.5-7-4-7-4v1.281c0 .56-.606.898-1.079.62z" })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Re-Launch", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: "btn btn-danger btn-lg my-5 d-flex align-items-center",
        onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.toHome && _ctx.toHome(...args)))
      }, _hoisted_8)
    ])
  ]))
};

defaultExport.render = render;

export default defaultExport;